import { render, staticRenderFns } from "./PlanRelation.vue?vue&type=template&id=2ec73c60&scoped=true"
import script from "./PlanRelation.vue?vue&type=script&lang=js"
export * from "./PlanRelation.vue?vue&type=script&lang=js"
import style0 from "./PlanRelation.vue?vue&type=style&index=0&id=2ec73c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec73c60",
  null
  
)

export default component.exports